import api from '../api';

export const uploadProfilePicture = (data) => api.post('/users/upload', data);

export const uploadResources = (data) => api.post('/resources/upload', data);
